import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatBadge } from '@angular/material/badge';
import {
  ClientNotificationService,
  IClientNotification,
} from '../../../customers-onboarding/services/client-notification.service';

/**
 * Header bell showing the customer's in-app notifications (e.g. the outcome of an
 * introducer request). Reads from BC_Identity via {@link ClientNotificationService}.
 */
@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [
    AsyncPipe,
    DatePipe,
    NgClass,
    MatIcon,
    MatIconButton,
    MatButton,
    MatMenu,
    MatMenuTrigger,
    MatBadge,
  ],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit {
  private readonly service = inject(ClientNotificationService);

  readonly notifications$ = this.service.notifications$;
  readonly unreadCount$ = this.service.unreadCount$;

  ngOnInit(): void {
    this.service.refresh();
  }

  onOpened(): void {
    // Re-fetch when the panel opens so the list is fresh.
    this.service.refresh();
  }

  onNotificationClick(n: IClientNotification): void {
    if (!n.isRead) {
      this.service.markRead(n.id).subscribe();
    }
  }

  markAllRead(event: Event): void {
    event.stopPropagation();
    this.service.markAllRead().subscribe();
  }

  iconFor(type: string | null): string {
    switch (type) {
      case 'IntroducerApproved':
        return 'verified';
      case 'IntroducerRejected':
        return 'cancel';
      case 'ApplicationChangesRequested':
        return 'assignment_late';
      default:
        return 'notifications';
    }
  }
}
